import { render, staticRenderFns } from "./BCXUserBannerSimple.vue?vue&type=template&id=eb803c72&scoped=true"
import script from "./BCXUserBannerSimple.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXUserBannerSimple.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXUserBannerSimple.vue?vue&type=style&index=0&id=eb803c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb803c72",
  null
  
)

export default component.exports